import {
  componentsTranslation,
  ComponentsTranslation,
} from '@/assets/locales/components/components.translation.pl.ts';
import {
  generalErrorTranslation,
  GeneralErrorTranslation,
} from '@/assets/locales/generalError/generalError.translation.pl.ts';
import {
  topBarTranslation,
  TopBarTranslation,
} from '@/assets/locales/topBar/topBar.translation.pl.ts';
import { utilsTranslation, UtilsTranslation } from '@/assets/locales/utils/utils.translation.pl.ts';
import {
  ValidationTranslation,
  validationTranslation,
} from '@/assets/locales/validation/validation.translation.pl.ts';

import {
  leftNavigationBarTranslation,
  LeftNavigationBarTranslation,
} from './menu/leftNavigationBar.translation.pl.ts';
import {
  routeDescriptionsTranslation,
  RouteDescriptionsTranslation,
} from './menu/routeDescriptions.translation.pl.ts';
import { viewsTranslation, ViewsTranslation } from './views/views.translation.pl.ts';

interface Translations {
  [I18N_NAMESPACE: string]: {
    components: ComponentsTranslation;
    generalError: GeneralErrorTranslation;
    leftNavigationBar: LeftNavigationBarTranslation;
    routeDescriptions: RouteDescriptionsTranslation;
    topBar: TopBarTranslation;
    utils: UtilsTranslation;
    validation: ValidationTranslation;
    views: ViewsTranslation;
  };
}

export const I18N_NAMESPACE = 'jm';

export const pl: Translations = {
  [I18N_NAMESPACE]: {
    components: componentsTranslation,
    generalError: generalErrorTranslation,
    leftNavigationBar: leftNavigationBarTranslation,
    routeDescriptions: routeDescriptionsTranslation,
    topBar: topBarTranslation,
    utils: utilsTranslation,
    validation: validationTranslation,
    views: viewsTranslation,
  },
};
